export const en_EN_the_prophet = [
  {
    slug: 'front-cover-prophet-english',
    name: 'Front Cover - The Prophet Muhammad (PBUH)',
    markdown: `

<div style="position: relative; height: 100vh; background-color: #f5f0e6; background-image: url('https://www.textures.com/system/gallery/photos/Paper/Cardboard/Plain/135679/CardboardPlain0020_600.jpg'); background-size: cover; background-position: center; display: flex; flex-direction: column; justify-content: space-between; align-items: center; padding: 80px 60px; box-sizing: border-box; border: 12px double #d4c4a8; text-align: center; color: #1a3c34; page-break-after: always;">

<div style="margin-top: 0px;">
  <p style="font-size: 12px; font-style: italic; letter-spacing: 2px; color: #1a3c34;">
    THE PERFECT EXEMPLAR FOR HUMANITY
  </p>
  <h1 style="font-size: 12px; margin-top: 20px; color: #1a3c34; direction: rtl; font-family: 'Scheherazade', 'Amiri', serif;">
    صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ
  </h1>
</div>

    
<div style="">
  <p style="font-size: 25px; font-style: italic; letter-spacing: 1px; color: #1a3c34;">
    A Real Sketch of
  </p>
  <h2 style="font-size: 25px; margin: 20px 0; color: #1a3c34;">
    THE PROPHET
  </h2>
  <h1 style="font-size: 42px; font-weight: bold; color: #006400; letter-spacing: 6px; text-shadow: 3px 3px 6px rgba(0,0,0,0.4);">
    MUHAMMAD
  </h1>
  <p style="font-size: 20px; margin-top: 20px; color: #1a3c34; font-style: italic;">
    (Peace Be Upon Him)
  </p>
</div>

<div style="background-color: rgba(255,255,255,0.9); padding: 25px 50px; border-radius: 12px; border: 3px solid #d4c4a8;">
  <h3 style="font-size: 20px; color: #1a3c34; margin: 0; line-height: 1.4;">
    MINHAJ-UL-QURAN<br>INTERNATIONAL
  </h3>
</div>

</div>

<hr style="page-break-after: always;" />
    
`,
  },
  {
    slug: 'bismillah-page',
    name: 'Bismillah Opening Page',
    markdown: `
<div style="height: 100vh; background-color: #f9f7f4; display: flex; justify-content: center; align-items: center; text-align: center; page-break-after: always;">

<div style="transform: translateY(-20px);">
  <p style="font-size: 25px; color: #1a3c34; font-family: 'Amiri', 'Scheherazade', serif; direction: rtl; letter-spacing: 2px;">
    بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ
  </p>
  <p style="font-size: 28px; margin-top: 40px; color: #4a6b5e; font-style: italic;">
    In the Name of Allah, the Most Gracious, the Most Merciful
  </p>
</div>

</div>

<hr style="page-break-after: always;" />
`,
  },
  {
    slug: 'traits-of-islam',
    name: 'Traits of Islam Page',
    markdown: `

# TRAITS OF ISLAM

<div style="font-size: 18px; text-align: center;">
    LOVE
    MERCY
    COMPASSION
    KINDNESS<br>
    LIBERALNESS
    TOLERANCE
    BENEVOLENCE<br>
    FORGIVENESS
    FORBEARANCE<br>
    ALTRUISM
    CHARITY<br>
    PEACE
    MODERATION
  </div>

  <p style="font-size: 20px;text-align: center; margin-top: 80px; color: #4a6b5e; font-style: italic;">
    Minhaj-ul-Quran International (MQI)
  </p>
</div>

</div>
        
<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'table-of-contents',
    name: 'Contents / Table of Contents (Full)',
    markdown: `

<h1 style="text-align: center;">
  CONTENTS
</h1>

### PART I
General Description of the Personality of the Most Perfect and Beautiful Human: The Holy Prophet Muhammad ﷺ

### PART II
Specific Descriptions Outlining the True Image of the Personality of the Holy Prophet Muhammad ﷺ
<h1 style="text-align: center;">
  CONTENTS
</h1>


1. The Most Noble of Lineage ................................. 43<br>
2. The Embodiment of Beauty ................................ 44<br>
3. The Possessor of Excellent Names and Titles ................... 46<br>
4. The One with the Highest Moral Character ...... 48<br>
5. The Most Humble ................................................ 49<br>
6. The Most Truthful and Honest ............................ 50<br>
7. The Most Just and Fair ...................................... 51<br>
8. The Most Generous ........................................... 52<br>
9. The Extraordinary Gentle .................................. 53<br>
10. The Possessor of a Soft Personality .................. 54<br>
11. The Most Dignified in Speech ............................ 55<br>
12. The Paragon of Mercy ..................................... 57<br>
13. The Ambassador of Peace ............................... 58<br>
14. The Helper of the Weak and Indigent .............. 59<br>
15. The Carer for the Sick Slaves .............................. 61<br>
16. The Emancipator of Slaves ................................. 62<br>
17. The Protector of Refugees .................................. 63<br>
18. The Advocate for Animal Rights ......................... 64<br>
19. The First to Speak Against Racism ..................... 65<br>
20. The Honourer of People’s Humanity .................. 66<br>
21. The Facilitator of Ease for People ...................... 67<br>
22. The Kindest to His Family ................................... 68<br>
23. The Caretaker of Widows and Orphans ........... 69<br>
24. An Advocate for Women’s Rights and Dignity ..70<br>
25. An Affectionate to Children .............................. 72<br>
26. The Best Neighbour ........................................ 74<br>
27. The Appreciative of People’s Efforts .............. 75<br>
28. The Most Respectful of Others ...................... 76<br>
29. The True Humanitarian and Philanthropist ... 77<br>
30. The Ambassador of Interfaith Harmony ....... 78<br>
31. The Striver for Social Cohesion ..................................... 79<br>
32. The Honourer of People of Different Ethnicities ............ 80<br>
33. The Remover of Enmity and Hatred ............................... 81<br>
34. The Opposer of Anti-Semitism ....................................... 83<br>
35. The Acknowledger of Virtues ......................................... 84<br>
36. The Proponent of Love ................................... 84<br>
37. The Respectful of Other Faiths ....................................... 85<br>
38. The Protector of Non-Muslims ....................................... 86<br>
39. The Reverent of the Past Prophets .................................. 88<br>
40. The Greatest Forgiver ...................................... 89<br>
41. The Rejecter of Revenge ................................. 90<br>
42. The Most Lenient in Dealings ......................................... 91<br>
43. The Most Forbearing and Patient ................................... 92<br>
44. The Controller of Anger .................................. 93<br>
45. The One Who Does not Curse ....................................... 94<br>
46. The Most Merciful Towards the Sinners ........................ 95<br>
47. The Provider of the Most Beautiful Company ................ 97<br>
48. The Most Loving towards His Followers ....................... 99<br>
49. The One Who Greeted Others Warmly ....................... 101<br>
50. The Lover of Knowledge and Wisdom .......................... 102<br>
51. The Advocate for the Environment ............................... 103<br>
52. The Teacher of Hygiene ................................ 104<br>
53. The Founder of the First Constitution ........................... 105<br>
54. The Great Manager ....................................... 106<br>
55. The Advocate of Moderation ....................................... 107<br>
56. The Teacher of Self-Restraint ....................................... 108<br>
57. The Encourager of Cooperation in Goodness ............... 109<br>
58. The Introducer of Justness in Warfare .......................... 110<br>
59. The Introducer of Justness in Wasting .......................... 111<br>
60. The Best in Handling Criticism ............................... 112<br>
61. The Best User of His Time .............................. 113<br>
62. His Teachings ............................................... 114<br>
63. His Golden Principles .................................. 116<br>

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-1-opening',
    name: 'Part I - Opening Page',
    markdown: `
<h1 style="font-size: 24px; margin-bottom: 10px; color: #1a3c34;">
  PART I
</h1>

<h3 style="font-size: 18px;">
  GENERAL DESCRIPTION<br>
  OF THE PERSONALITY OF<br>
  THE MOST PERFECT AND<br>
  BEAUTIFUL HUMAN:<br>
  THE HOLY PROPHET<br>
  MUHAMMAD ﷺ
</h3>

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-1-chapter',
    name: 'Part I - Chapter Content (Pages 3–5)',
    markdown: `

The Holy Prophet Muhammad ﷺ was the most perfect human being. He was born in the city of Mecca in Arabia, during the early hours of Monday, the twelfth of Rabi‘ al-Awwal in the year of the Elephant (570 AD)—fifty-two days after the armies of Abraha advanced to destroy the Ka‘ba.

1. **HIS CREATION: God Most High, in His mercy, sent His Beloved ﷺ as a mercy to the universe.** Prophet Muhammad ﷺ was the one whose soul God created the first. It was created through the direct blessing of God’s light, before anything else of the universe had come into existence. It is reported that the Prophet ﷺ said: “The first creation that God brought into existence was the light of your prophet from His light.”¹

2. **Light of the Prophet ﷺ means his enlightened and illuminating soul.** Whereas being created from the light of God, does not tell that it was a part of God’s light or it emerged from God’s light. Glory be to Him. God Almighty Himself is not light. Instead, He is the Creator of light.

3. **Creating from His light implies that God Almighty created the Prophet Muhammad’s soul as His first creation of the universe without any intermediary means,** as usual in the process of creation, for none amongst His creation existed at that time.

4. **The expression “from His light”, refers to glorification of a particular divine act,** to mention the highly esteemed and exceptionally honoured status of the blessed one, who has been miraculously created, through the special grace of the Lord Almighty.

¹ Set forth by •Abd al-Razzāq in al-Musannaf (al-Juz’ al-Mafqūd), 1:63 §63. •al-Qastallānī in al-Mawāhib al-Laduniyya bi al-Minh al-Muhammadiyya, 1:71. •al-Halabi in al-Sīra al-Halabiyya, 1:50.

</div>

<hr style="page-break-after: always;" />
`,
  },
  {
    slug: 'part-1-page-5',
    name: 'Part I - Page 5 Continuation',
    markdown: `

5. A similar style of expression has been used in the Qur’an, mentioning the creation of Adam, Jesus and human beings. It is stated regarding the creation of humans: «Then He proportioned him and breathed into him of His spirit.» [Q.32:9.]

   It is stated regarding the creation of Adam: «So when I have proportioned him and blown into him from My spirit, then fall down in prostration before him (in his honour).» [Q.38:72.]

   The similar expression has been used for the creation of Jesus: «The Messiah, Jesus, son of Maryam (Mary) was only Allah’s Messenger, and His Word, which He conveyed to Maryam (Mary), and a Spirit from Him. So believe in Allah and His messengers and do not say: ‘Three’. Refrain (from this belief). It is better for you. Indeed Allah is Only One God.» [Q.4:171.]

6. Therefore, this miraculous and blessed creation of the light (soul) of the most beloved and esteemed Prophet Muhammad ﷺ has been mentioned in another hadith, in the words: “The first creation that Allah brought into existence was my light (soul).”¹

7. He was the first of all the Prophets ﷺ, as he said: “I was a Prophet when Adam was between soul and body.”²

8. He was also the last of all Prophets ﷺ, as he said: “I was the first Prophet in creation, and the last of them in raising.”³

¹ Set forth by •al-Halabi in Insān al-‘Uyūn fī Sīra al-Amīn al-Ma’mūn, 1:240.

² Set forth by •Ibn Abi Shayba in al-Musannaf, 7:329 §3653. •Ibn Abi Sa‘d in al-Tabaqāt al-Kubrā, 1:148.

³ Set forth by •al-Tabarānī in Musnad al-Shāmiyyīn, 4:334-35 §2662. •Tanzīl, 3:508.

</div>
<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-1-page-right',
    name: 'Part I - Right Page (Physical Appearance)',
    markdown: `

9. He said: “I am the last of all prophets and no other prophet or messenger would be raised after me.” He further explained that the Divine process of raising the prophets and messengers has been completed and stopped with my raising.”²

10. He said: “I have completed the construction of the palace of the prophethood and there is no space left for any other brick to be placed in it.”³

11. He grew an orphan as his father, ‘Abd Allāh, died before he was born and his mother, Āmina, died when he was a young child.

12. **HIS PHYSICAL APPEARANCE:** He had broad shoulders⁴ and a broad high chest. He was strongly built; his chest and stomach were flat and firm. No part of his flesh was loose.⁵ On his back, between his shoulders, was the Seal of Prophethood.⁶ His complexion was white tinged with red.

¹ Set forth by •al-Tirmidhī in al-Sunan, 4:499 §2219.

² Set forth by •Ibn Hibbān in al-Sahīh, 14:316 §6406.

³ Set forth by •al-Bukhārī in al-Sahīh, 3:1300 §3341–3342. •Muslim in al-Sahīh, 4:1791 §§2286–2287.

⁴ Set forth by •al-Bukhārī in al-Sahīh, 3:1303 §3356. •Muslim in al-Sahīh, 4:1819 §2337.

⁵ Set forth by •al-Bukhārī in al-Sahīh, 3:1303 §3358. •Muslim in al-Sahīh, 4:1818 §2337.

⁶ Set forth by •al-Tirmidhī in al-Shamā’il al-Muhammadiyya, pp. 36–38 §8.

</div>

<hr style="page-break-after: always;" />
`,
  },
  {
    slug: 'part-2-opening',
    name: 'Part II - Opening Page',
    markdown: `
# PART II

<h3 style="font-size: 20px; line-height: 1.4; color: #1a3c34;">
  SPECIFIC DESCRIPTIONS<br>
  OUTLINING THE TRUE IMAGE<br>
  OF THE PERSONALITY OF<br>
  THE HOLY PROPHET<br>
  MUHAMMAD ﷺ
</h3>
<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-2-chapter-1',
    name: 'Part II - 1. The Most Noble of Lineage',
    markdown: `
# 1. **THE MOST NOBLE OF LINEAGE**

The Prophet Muhammad ﷺ was born in a modest family of noble lineage. He ﷺ was a descendant of Prophet Abraham ﷺ and was from the best tribes of the Arabs, which was the tribe of Quraysh. From within the Quraysh, he ﷺ came from the most noble of the families known as the clan of Hāshim. His grandfather ‘Abd al-Muttalib ﷺ was the custodian of the Ka‘ba and the chief of Mecca. Thus, he came from a noble lineage from a highly respected and honourable family.

Informing his Companions ﷺ about his family background, the Prophet Muhammad ﷺ said, “I am Muhammad b. ‘Abd Allāh b. ‘Abd al-Muttalib. Indeed, God created the creation, and He put me in the best group of them, then He made them into two groups, so He put me in the best group of them, then He made them into tribes, so He put me in the best of tribes, then He made them into houses, so He put me in the best of them in tribe and lineage.”¹

¹ Set forth by •Ahmad b. Hanbal in al-Musnad, 1:210 §1788. •al-Tirmidhī in al-Sunan, 5:543, 584 §§3532, 3607–3608.

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-2-chapter-2',
    name: 'Part II - 2. The Embodiment of Beauty',
    markdown: `
# 2. **THE EMBODIMENT OF BEAUTY**

The Companions ﷺ of the Prophet ﷺ had preserved a description of the physical beauty of Prophet Muhammad ﷺ. They said that he ﷺ was the most excellent of countenance with the finest of character.¹ They agreed that there was none more beautiful than him ﷺ.²

Concerning his physical appearance, they said that he ﷺ had a bright appearance as though he was made from light³ and that his teeth would glisten like they were pearls.⁴ He was neither too tall nor short but was slightly taller than medium height and his body was perfectly proportioned.⁵ His face was neither long, nor round, but in between the two.⁶ His skin was as soft as silk⁷ and he ﷺ had a beautiful fragrance like that of musk.⁸

¹ Set forth by •al-Bukhārī in al-Sahīh, 3:1303 §3356. •Muslim in al-Sahīh, 4:1819 §2337.

² Set forth by •al-Bukhārī in al-Sahīh, 3:1303 §3358. •Muslim in al-Sahīh, 4:1818 §2337.

³ Set forth by •al-Dārimī in al-Sunan, 1:44 §57.

⁴ Set forth by •al-Tirmidhī in al-Shamā’il al-Muhammadiyya, pp. 36–38 §8.

⁵ Set forth by •al-Tirmidhī in al-Sunan, 5:599 §3638.

⁶ Set forth by •al-Bayjūrī in al-Mawāhib al-Laduniyya ‘alā al-Shamā’il al-Muhammadiyya, p. 25.

⁷ Set forth by •al-Bukhārī in al-Sahīh, 2:696 §1872.

⁸ Set forth by •al-Bukhārī in al-Sahīh, 2:696 §1872.

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-2-chapter-3',
    name: 'Part II - 3. The Possessor of Excellent Names and Titles',
    markdown: `
# 3. **THE POSSESSOR OF EXCELLENT NAMES AND TITLES**

Prophet Muhammad ﷺ had many excellent names and titles. His name ‘Muhammad’ means ‘the Praised One’.¹ This name was not common amongst the Arabs before him.² However, it is amongst the most common names in the world today with approximately 150 million people in the world bearing this name with all its different variations in spelling.

Before announcing his Prophethood, Prophet Muhammad ﷺ was known as ‘al-Amīn’, which means ‘the Honest’.³ This title was given to him by his society because he was known for his truthfulness and integrity. Likewise, before he was sent as God’s Prophet, the Prophets of former communities, such as Prophets Moses and Jesus ﷺ, had given glad tidings of his coming. They would refer to him by the name ‘Ahmad’, which means the ‘Most Praised’.⁴ This name is from the same root as the name ‘Muhammad’.

The Prophet Muhammad ﷺ whilst discussing with his Companions ﷺ about the different titles given to the Prophets ﷺ said that he was conferred the title ‘Habīb Allāh’, which means the ‘Beloved of God’.⁵ In the Holy Bible, he is given

¹ Set forth by •al-Rāghib al-Asfahānī in al-Mufradāt, p. 131.

² Set forth by •al-Qustulānī in al-Mawāhib al-Laduniyya, 2:38.

³ Set forth by •al-Qurtubī in al-Jāmi‘ li-Ahkām al-Qur’ān, 6:416.

⁴ Qur’ān 61:6.

⁵ Set forth by •al-Tirmidhī in al-Sunan, 5:587 §3616. •al-Dārimī in al-Sunan, 1:42 §54.

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-2-chapter-5',
    name: 'Part II - 5. The Most Humble',
    markdown: `
# 5. **THE MOST HUMBLE**

The beloved Prophet of God ﷺ was humble and he loved humbleness and humility. He ﷺ disliked pride and arrogance. From his humility,¹ he ﷺ would sit on the floor, eat sitting on the ground and accept the invitations of slaves and eat the food that they ate. He ﷺ would partake in the household chores with his family and would sit with the poor and weak. He ﷺ taught others to humble themselves and not to feel superiority over others, as the one who thinks he is superior to others will be brought down by God.²

¹ Set forth by •Muslim in al-Sahīh, 4:2198 §2865.

² Set forth by •al-Bukhārī in al-Sahīh, 5:2255 §5724. •al-Tirmidhī in al-Sunan, 3:337 §1017. •al-Tabarānī in al-Mu‘jam al-Kabīr, 12:67 §6735. •al-Bayhaqī in Shu‘ab al-Īmān, 6:290 §8192.

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-2-chapter-6',
    name: 'Part II - 6. The Most Truthful and Honest',
    markdown: `
# 6. **THE MOST TRUTHFUL AND HONEST**

Abū Sufyān ﷺ was amongst the Meccans who embraced Islam towards the end of the Prophet’s life. For most part of 23 years, he had opposed Islam and had waged bitter wars against the Prophet ﷺ. Once before becoming a Muslim, he went onto a business trip to Syria. He found himself at the court of Heraclius, who asked him about the Prophet Muhammad ﷺ. Heraclius asked: “Have you ever accused him of telling lies before his claim (to be a Prophet)?” Abū Sufyān replied, “No.” Heraclius then asked: “Does he break his promises?” And Abū Sufyān replied, “No.”

Commenting on Abū Sufyān’s reply, Heraclius said: “If he does not lie to people, then certainly he will not lie about God… such is the practice of the Prophets that they do not deceive others.” In fact, the Prophet ﷺ was known for his truthfulness and honesty among his people that even his most bitter enemies would entrust their valuables and belongings to him as they knew that there was no one more truthful and trustworthy than him. The Jewish Rabbi ‘Abd Allāh b. Salām, when he first saw the Prophet ﷺ, noted: “When I looked at the face of the Messenger of God, I realised that his face was not the face of a liar.”¹

¹ Set forth by •al-Bukhārī in al-Sahīh, 1:7–8 §7. •Muslim in al-Sahīh, 3:1393–1395 §1773.

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'part-2-chapter-7',
    name: 'Part II - 7. The Most Just and Fair',
    markdown: `
# 7. **THE MOST JUST AND FAIR**

The Prophet Muhammad ﷺ treated people fairly. He did not allow Muslims to oppress non-Muslims and get away with it. He ﷺ said: “If a Muslim kills a Christian, he will be killed (in retaliation).”¹

On another occasion, a woman from the powerful tribes of Mecca was found guilty of stealing. So, the Holy Prophet ﷺ passed judgement that she would be punished. However, some of the Companions ﷺ tried to plead with the Prophet ﷺ not to punish her because she came from a rich family. But the Prophet ﷺ instead got up and addressed his Companions ﷺ, saying: “Those before were destroyed because when the elites among them stole (i.e. committed a crime), they would let them off, but if some poor person stole they would punish him (for his crime). By God, if Fātima, the daughter of Muhammad, stole, I would cut her hand also (i.e. punish her for her crime).”²

From this anecdote we can see the principle of equality before the law that no one is above the law. The Prophet’s justice and fairness was so great that he would not allow the elite to get away with their crimes and punish only the common people. He ﷺ declared that even his own family must abide by the law and not contravene it.

¹ Set forth by •al-Shāfi‘ī in al-Musnad, p. 343. •al-Bayhaqī in al-Sunan al-Kubrā, 8:30 §15696.

² Set forth by •al-Bukhārī in al-Sahīh, 3:1366 §3526. •Muslim in al-Sahīh, 3:1315 §1688.

<hr style="page-break-after: always;" />

`,
  },
]